import PaymentMethodSlideGroup from './payment-method-slide-group.vue';

export default PaymentMethodSlideGroup;
